/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

import { Placeholder, TextareaControl, Button, TextControl, PanelBody, BaseControl } from '@wordpress/components';

import { InspectorControls } from '@wordpress/block-editor';
/**
 * Icons
 */
import icons from './icons.js';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit(props) {
    const { attributes, setAttributes, blockProps } = props;

    const { customPrompt, submitText } = attributes;
    /* let parentBlockObj = null;
    const parentBlocks = useSelect((select) => select('core/block-editor').getBlockParents(clientId));
    parentBlocks.forEach((parentId) => {
        const parentBlock = wp.data.select('core/block-editor').getBlock(parentId);
        if (parentBlock && parentBlock.name === 'momo-acg-forms/momo-form-container') {
          // Do something with the matching parent block
          console.log('Matching parent block found:', parentBlock);
          parentBlockObj = parentBlock;
        }
    });
    if (parentBlockObj && parentBlockObj.innerBlocks) {
        const childBlocks = parentBlockObj.innerBlocks;

        childBlocks.forEach((childBlock) => {
            if (childBlock.name === 'momo-acg-forms/momo-form-elements') {
            // Do something with the matching child block
            console.log('Matching Child Block:', childBlock);
            }
        });
    } */
    const onChangeCustomPrompt = (newText) => {
        setAttributes({ customPrompt: newText });
    };
    const handleSubmitChange = (newText) => {
        setAttributes({ submitText: newText });
    };
    return(
        <div { ...blockProps } >
            <InspectorControls>
                <PanelBody title="Block Settings" initialOpen={true}>
                    <BaseControl help={__('While creating a prompt you can use form element ID inside curly bracket to replace user input with prompt. For eg: <code>What is the capital of {text-control-country} ?</code>', 'momoacg')}>
                        <TextareaControl
                            label= {__('Custom Prompt', 'momoacg')}
                            value={customPrompt}
                            onChange={onChangeCustomPrompt}
                        />
                    </BaseControl>
                    <TextControl
                        label={__('Submit Button Text', 'momoacg')}
                        value={submitText}
                        onChange={handleSubmitChange}
                    />
                </PanelBody>
            </InspectorControls>
            <div className="momo-acg-ai-form-submit-bottom">
                <Button id="momo-generate-output-from-form" variant='primary'>{submitText}</Button>
            </div>
            <Placeholder
                icon={icons.content}
                label={ __('MoMo Form Result', 'momoacg') }
                instructions= { __('This is where your result will be printed. In Block Settings you can create your own custom prompt with the help of Form elements ID that you\'ve inserted inside the Form container', 'momoacg') }
                isColumnLayout
            ></Placeholder>
        </div>
    );
}